<script setup>
defineProps({
  text: {
    type: String,
    default: undefined,
  },
  items: {
    type: Array,
    default: () => [],
  },
  inSidebar: {
    type: Boolean,
    default: false,
  },
});
function getText({ title, text }) {
  let result = '';

  if (title) result += `<p><strong>${title}</strong></p>`;
  if (text) result += `<p>${text}</p>`;

  return result;
}
</script>

<template>
  <div class="ctr-list-numbered ctr-list-numbered-images" :class="{ container: !inSidebar }">
    <div
      v-for="(item, index) in items"
      :key="`card-${index}`"
      class="ctr-list-numbered__item"
    >
      <div class="ctr-list-numbered__step">
        <span class="ctr-list-numbered__font ctr-list-numbered__font--number">
          {{ $tp(item.num) }}
        </span>
      </div>
      <div
        class="ui-html-content ui-html-content--font ctr-list-numbered__text"
      >
        <UiHtmlContent
          v-if="item?.text"
          class="ctr-list-numbered__text"
          :content="getText(item)"
        />
        <UiHtmlContent
          v-if="item?.bottomText"
          class="ctr-list-numbered__subtxt"
          :content="item.bottomText"
        />
        <div v-if="item.images" class="ctr-list-numbered__img">
          <div class="ctr-list-numbered__img--item" v-for="(image, index) in item.images" :key="index">
            <img :src="image" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.ctr-list-numbered {
  display: flex;
  flex-direction: column;

  @include media-breakpoint-down(sm) {
    margin-top: 32px;
  }

  &__text {
    padding-top: 10px;
    @include media-breakpoint-down(sm) {
      padding-top: 0;
    }
  }

  &__subtxt {
    color: #666666;
    margin-top: 2lh;
  }

  &__img {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: em(20);
    margin-top: 24px;
    &--item {
      @include media-breakpoint-down(sm) {
        width: calc(100% / 3 - 5.4px);
      }
    }
    @include media-breakpoint-down(sm) {
      gap: 8px;
    }
    img {
      width: 120px;
      height: 120px;
      object-fit: cover;
      @include media-breakpoint-down(sm) {
        aspect-ratio: 1 / 1;
        height: auto;
        width: 100%;
      }
    }
  }

  &__item {
    display: flex;
    gap: em(43);
    margin-top: 72px;
    padding-bottom: 72px;
    border-bottom: 1px solid $color-gray-1;
    &:last-child {
      border: 0;
      padding-bottom: 0;
    }

    @include media-breakpoint-down(sm) {
      gap: em(14);
      margin-top: 40px;
      padding-bottom: 40px;
    }
  }

  &__step {
    flex-shrink: 0;
    width: em(80);

    @include media-breakpoint-down(sm) {
      width: em(40);
    }
  }

  &__font {
    &--number {
      flex-shrink: 0;
      font-size: em(128);
      color: $color-red-1;

      @include media-breakpoint-down(sm) {
        font-size: em(64);
      }
    }
  }
}
</style>
